import React, { useState, useEffect } from 'react';

export function TradeMultiRequestModalLoader({ load, ...props }) {
    const [LazyModal, setLazyModal] = useState(null);
    useEffect(() => {
        if (load && !LazyModal) {
            setLazyModal(
                React.lazy(() =>
                    import(
                        /* webpackChunkName: "TradeMultiRequestModal" */ './TradeMultiRequestModalRenderer'
                    )
                )
            );
        }
    }, [LazyModal, load]);
    return (
        LazyModal && (
            <React.Suspense fallback={''}>
                <LazyModal {...props} />
            </React.Suspense>
        )
    );
}
